import classnames from "classnames";

import { WishlistModel } from "@/redux/modules/api/data/wishlist/@types/wishlist.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import "./WishlistListItem.scss";

type WishlistListItemProps = {
    list: WishlistModel;
    isSelected: boolean;
    onSelect: (id: string) => void;
};

const WishlistListItem = ({
    list,
    isSelected,
    onSelect
}: WishlistListItemProps) => {
    const { t } = useGranite();

    const itemCount = list.products.length;

    return (
        <a
            className={classnames(
                "wishlist-item",
                {
                    "wishlist-item__current": isSelected
                },
                "py-1 px-2"
            )}
            onClick={() => onSelect(list.id)}
        >
            {list.name || t("wishlist.wishlistName")}
            <span className="wishlist-item__count pt-1">
                {t(
                    `wishlist.item.itemcount.${
                        itemCount === 0
                            ? "none"
                            : itemCount > 1
                              ? "multiple"
                              : "single"
                    }`,
                    itemCount
                )}
            </span>
        </a>
    );
};

export { WishlistListItem };
